import React from 'react';
import { ButtonRow } from '~ui';
import Main from './main';

export default function BookmarkEditAction({ buttons, ...etc }) {
  return (
    <ButtonRow variant={buttons ? 'between' : undefined}>
      {buttons}
      <Main {...etc} />
    </ButtonRow>
  );
}
